export default __webpack_public_path__ + "static/media/anpc-sal.1ec039b2.svg";